import { gql } from '@apollo/client/core';
import LocationService from '@/services/LocationService';
import { executeQuery } from '@/components/commons/utils.js';
import Tracking from '@/components/commons/Tracking';

const MESSAGING_QUERY = gql`
  query MESSAGING($zip: String) {
    messaging(zip: $zip) {
      legacyShippingDiscountDetails
      legacyShippingDiscountMessage
      baselineShippingCostDiscounted
      shippingDiscountThreshold
      baselineShippingCost
      message {
        id
        countryId
        text
        etaText
        active
        name
        createdDate
      }
    }
  }
`;

export default class MessagingService {
  static async fetchMessaging(zip) {
    const zipcode = zip || LocationService.getPreferredLocation().zipcode;

    try {
      const result = await executeQuery(MESSAGING_QUERY, {
        zip: zipcode,
      });

      return {
        messaging: result.messaging,
      };
    } catch (error) {
      Tracking.sentryCaptureError(error);
      return {
        error,
      };
    }
  }
}
